module.exports = __webpack_public_path__ + "img/DE02856.efe42a44.png";